import { formattedMessageParams } from "../../messages";

export function enhanceDataWithManagerApproval({
  sections,
  fields,
  managedTravellers,
  cbt,
  intl,
}) {
  const managers = Object.values(cbt.managers) || [];

  const passengersIndexesToAddManager = Object.keys(fields)
    .filter((key) => isPassengerIndexToAdd(key, managedTravellers, fields))
    .map((field) => field.substring(0, field.indexOf("-")));

  const newFields = passengersIndexesToAddManager.reduce(
    (acc, curr) =>
      addManagerToFields({ passengerIdx: curr, fields: acc, managers, intl }),
    fields
  );
  const newSections = passengersIndexesToAddManager.reduce(
    (acc, curr) => addManagerToSections({ passengerIdx: curr, sections: acc }),
    sections
  );
  return {
    sections: newSections,
    fields: newFields,
  };
}

function isPassengerIndexToAdd(key, managedTravellers, fields) {
  if (!key.includes("-passenger_email") && !key.includes("-traveler_email")) {
    return false;
  }
  if (fields[key].value && fields[key].value.length > 1) {
    const shouldDisplayTraveller = !!managedTravellers.travellers.find(
      ({ Email }) => {
        return Email === fields[key].value;
      }
    );
    return shouldDisplayTraveller || managedTravellers.shouldDisplayGuests;
  }

  return managedTravellers.shouldDisplayGuests;
}

function addManagerToFields({ passengerIdx, fields, managers, intl }) {
  return {
    ...fields,
    [`${passengerIdx}-manager`]: {
      name: `${passengerIdx}-manager`,
      required: true,
      label: intl.formatMessage(formattedMessageParams("ResultForm.manager")),
      format: "alphanumeric",
      type: "select",
      options: managers.map(({ label, value }) => ({ value, label })),
      value: "",
    },
  };
}

function addManagerToSections({ passengerIdx, sections }) {
  return sections.map((section) => {
    const emailElement = section?.elements?.find(
      (it) =>
        it.includes(`${passengerIdx}-passenger_email`) ||
        it.includes(`${passengerIdx}-traveler_email`)
    );
    if (!emailElement) {
      return section;
    }
    const managerElement = section?.elements?.find((it) =>
      it.includes(`${passengerIdx}-manager`)
    );
    if (managerElement) {
      return section;
    }
    const newElements = [...section.elements, `${passengerIdx}-manager`];
    return { ...section, elements: newElements };
  });
}
